import React, { useRef } from 'react';
import cn from 'classnames';
import ModalStep from '../components/ModalStep';
import FormStep from '../components/FormStep';
import { observer, pricingCalculator as store } from 'store';
import { useNavigateSteps } from './hooks';

import * as styles from './ModalContent.module.scss';

function ModalContent({ id, steps, onClose, resetFirstStep }) {
  const stepsContainerRef = useRef(null);
  const { currentStep, getPayload } = store;
  const payload = getPayload();
  const withSummary = Boolean(Object.values(payload).flat().length);

  useNavigateSteps({
    stepsContainerRef,
    currentStep,
  });

  return (
    <div className={styles.contentWrapper} ref={stepsContainerRef}>
      {steps?.map((step, i) => (
        <ModalStep
          key={`${step?.title}-${i}`}
          {...step}
          className={cn(styles.step, i === 0 && styles.first, withSummary && styles.withSummary)}
        />
      ))}
      <FormStep
        key={id}
        id={id}
        steps={steps}
        onClose={onClose}
        resetFirstStep={resetFirstStep}
        className={cn(styles.step, withSummary && styles.withSummary)}
      />
    </div>
  );
}

export default observer(ModalContent);
